import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-imprimir-controle',
  templateUrl: './imprimir-controle.component.html',
  styleUrls: ['./imprimir-controle.component.scss']
})
export class ImprimirControleComponent implements OnInit {
  
  loading = false;
  tipo;

  public codControle = new FormControl('');

  constructor(public dialogRef: MatDialogRef<ImprimirControleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.tipo = data.tipoSolicitacao;
     }

  ngOnInit() {
  }

  relatorioControle() {
    if (this.codControle.value !== null && this.codControle.value > 0) {
      console.log(this.tipo);
      if (this.tipo === '0') {
        window.open(`relatorio-controle/${this.codControle.value}/0`,
        '_blank',
        'location=yes,scrollbars=yes,status=yes'); // Open new window
      } else {
        window.open(`relatorio-controle/${this.codControle.value}/1`,
      '_blank',
      'location=yes,scrollbars=yes,status=yes'); // Open new window
      }
      
    } else {
      alert('Digite um código válido !');
    }
    
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/solicitacao/imprimir-controle/imprimir-controle.component.ts